// Loginn.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { FaArrowLeft } from "react-icons/fa";
import ppp from "../Images/Login.webp";
import "./loginn.css";

const Loginn = () => {
  const [identifier, setIdentifier] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!identifier || !loginPassword) {
      toast.warn("Please fill in all fields.");
      return;
    }

    setLoading(true);
    try {
      const response = await Axios.post("https://api.litaxfilers.com/loginn", {
        identifier,
        password: loginPassword,
      });

      if (response.data.success) {
        const role = response.data.role;
        toast.success("Welcome!!");
        localStorage.setItem("role", role.toLowerCase());

        setTimeout(() => {
          Cookies.set("token", response.data.token);
          navigate(`/${role.toLowerCase()}`, { state: { identifier, role } });
        }, 1000);
      } else {
        toast.error("Invalid credentials");
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("An error occurred during login. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container-small">
      <div className="login-box-small">
        {/* Left Image Section */}
        <div className="login-image-small">
          <img src={ppp} alt="Login" className="login-image-content-small" />
        </div>

        {/* Right Form Section */}
        <div className="login-content-small">
          <Link to="/" className="login-back-link-small">
            <FaArrowLeft size={12} /> Back to Home
          </Link>

          <h1 className="login-title-small">Login</h1>

          <form className="login-form-small" onSubmit={handleLogin}>
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="Email or Mobile"
              className="login-input-small"
            />

            <input
              type="password"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
              placeholder="Password"
              className="login-input-small"
            />

            <button className="login-button-small" type="submit" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <p className="login-footer-small">
            Forgot your password?{" "}
            <Link to="/forgetpassword" className="login-link-small">
              Click here
            </Link>
          </p>
          <p className="login-footer-small">
            Don’t have an account?{" "}
            <Link to="/signup" className="login-link-small">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loginn;
